import { IconButton, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { openCreateLectureModel } from "../../../modules/admin-modules/models/Actions";
import { deletePdfRequest } from "../../../modules/superadmin-modules/lectures/Actions";
const PDFTable = ({ setAdd, setSelectedData }) => {
  const { pdfs, isLoading } = useSelector((state) => state.superadminPdfs);
  const dispatch = useDispatch();
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const Data = pdfs?.map((data) => {
    return {
      ...data,
      date: <Text>{dayjs(data?.date).format("D , MMM ,YYYY")}</Text>,
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={() => {
            setAdd(false);
            dispatch(openCreateLectureModel());
          }}
        />
      ),
      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiDeleteBinLine color="red" />}
          onClick={() => dispatch(deletePdfRequest(data?.id))}
        />
      ),
    };
  });
  const columns = [
    {
      Header: "عنوان الدرس",
      accessor: "title",
    },
    {
      Header: "ميعاد الحصة",
      accessor: "date",
    },
    {
      Header: "السنة الدراسية التابع له",
      accessor: "course.name",
    },
    {
      Header: "",
      accessor: "edit",
    },
    // {
    //   Header: "",
    //   accessor: "delete",
    // },
  ];

  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Actions
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(pdfs?.length / 10)}
    />
  );
};

export default PDFTable;
